import React from 'react'
import Breadcrumb from './Header/Breadcrumb';
import Header from './Header/Header';
import LayoutContent from './LayoutContent';

const Forbidden = () =>{
  return (
    <LayoutContent>
      <LayoutContent.Header>
        <Header>
        </Header>
      </LayoutContent.Header>
      <LayoutContent.Content
        style={{
          paddingLeft: "0px",
          paddingTop: "0px",
          backgroundColor: "#B4B4B4",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <div
          style={{
            height: 73,
            backgroundColor: "white",
            textAlign: "center",
            fontFamily: "Raleway",
            fontStyle: "normal",
            fontWeight: "normal",
            fontSize: 24,
            lineHeight: 28,
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <div>
            You don't have permission to view this page.
          </div>
        </div>
      </LayoutContent.Content>
    </LayoutContent>
  )
}

export default Forbidden;